import React from 'react';

const Documents = () => {
    return ( <h1>Your docs should be here!</h1>);
}

export default Documents;
